import { action, observable, computed } from 'mobx';

interface IMsg {
  msg: string;
  type: string;
  link?: string;
}

export default class FlashStore {
  
  private static _instance: FlashStore;

  private timeout: any;

  @observable
  private _msg: IMsg;

  public static GetInstance() {
    if (this._instance == undefined) {
      this._instance = new FlashStore();
    }

    return this._instance;
  }

  @computed
  public get getMessage() {
    return this._msg;
  }

  @action
  public showMessage(msg: string, type?: string, time?: number, link?: string) {
    if (!time) {
      time = 4000;
    }

    this._msg = {
      msg,
      type: type ? type : 'default',
      link
    };

    this.timeout = setTimeout(() => {
      this.clearMessage();
    }, time);
  }

  @action
  public clearMessage() {
    if (this._msg) {
      this._msg.msg = '';
      this._msg.link = '';
    }
  }

  constructor() {
    this._msg = {
      msg: '',
      type: '',
      link: ''
    };
  }
}



// WEBPACK FOOTER //
// ./src/services/FlashStore.ts